import React from "react"
import Slider from "react-slick"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import BlockTitle from "components/shared/BlockTitle"
import ContentMax from "components/shared/ContentMax"
import CarouselStyled from "components/shared/CarouselStyled"
import CarouselPrevButton from "components/shared/CarouselPrevButton"
import CarouselNextButton from "components/shared/CarouselNextButton"
import WPLink from "components/shared/WPLink"
import ContainerMax from "../../shared/ContainerMax"

const Wrap = styled(WPLink)`
	text-decoration: none;
	cursor: pointer;

	h4 {
		text-transform: uppercase;
		font-size: ${props => props.theme.font.h5.size};
		font-family: ${props => props.theme.font.family.heading};
		margin: 0;
		padding: .5rem 0 .25rem 0;
	}

	&:hover {
		text-decoration: none;
		h4 {
			color: ${props => props.theme.colors.primary};
		}
	}
`

const TheresMore = (props) => {
	const { block } = props
	const data = block.block.acfTheresMore

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		lazyload: true,
		prevArrow: <CarouselPrevButton />,
		nextArrow: <CarouselNextButton />,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
                    centerMode: true,
					centerPadding: '60px'
				}
			}
		]
	}

	const items = data.items.map((item, i) => {
		return(
			<div className="d-flex" key={i}>
				<Wrap url={item.link.url}>
					<GatsbyImage 
						image={item.image.localFile.childImageSharp.gatsbyImageData}
						alt={item.image.altText}
					/>
					{item.title &&
						<h4>{item.title}</h4>
					}
				</Wrap>
			</div>
		)
	})

	return(
		<ContainerMax className="my-4">
			<ContentMax>
				{data.title && 
					<BlockTitle baseTitle >
						{data.title}
					</BlockTitle>
				}
				<CarouselStyled itemCount={data.items.length} type="TheresMore" background="white">
					<Slider {...settings} >
						{items}
					</Slider>
				</CarouselStyled>
			</ContentMax>
		</ContainerMax>
	)
}

export default TheresMore